import React, { useEffect } from "react";
import { Link, NavLink  } from "react-router-dom";
import { ImageElement } from "../../../components";

function Sidebar({navbar}) {  
    useEffect(() =>{
        setTimeout(() => {
            document.querySelector(".sideBar").style.top = `${navbar}px`;
            document.querySelector(".sideBar").style.height = `${window.innerHeight - navbar}px`;
          }, 300);
    })
  return (
    <aside className="sideBar bg-white d-flex flex-column">
        <ul className="list-unstyled sideBar_menu">
            <li>
                <NavLink  to="/dashboard"><em className="gg-home"></em> Home</NavLink>
            </li>
            <li>
                <NavLink to="/my-bookings"><em className="gg-my-bookings"></em> My Bookings</NavLink>
            </li>
            <li>
                <NavLink to="/select-payment"><em className="gg-payment"></em> Payment</NavLink>
            </li>
            <li>
                <NavLink to="/apply-for-financing"><em className="gg-financing"></em> Apply For Financing</NavLink>
            </li>
            <li>
                <NavLink to="/search-service-provider"><em className="gg-service-provider"></em> Search Service Provider</NavLink>
            </li>
            <li>
                <NavLink to="/rating-review"><em className="gg-rating"></em> Rating & Review</NavLink>
            </li>
            <li>
                <NavLink to="/tip-of-the-month"><em className="gg-month"></em> Tip of the Month</NavLink>
            </li>
            <li>
                <NavLink to="/search-service-provider"><em className="gg-ask-expert"></em> Ask the Expert</NavLink>
            </li>
            <li>
                <NavLink to="/home"><em className="gg-sign-out"></em> Logout</NavLink>
            </li>
        </ul>
        <div className="sideBar_bottom">
            <p className="text-center">Meet the new Good Guys Service  <br /> Mobile app</p>
            <Link><ImageElement className="img-fluid" source="google-play-logo.svg" alt="Google-play" /></Link>
            <Link><ImageElement className="img-fluid" source="app-store-logo.svg" alt="App-play" /></Link>
        </div>
    </aside>
  );
}
  
export default Sidebar;